import { FC } from 'react';

import { formatNumber } from 'utils/formats';

import { CoOwner } from 'types';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

type CoOwnersTableRowProps = {
  index: number;
  coOwner: CoOwner;
};

const CoOwnersTableRow: FC<CoOwnersTableRowProps> = ({ index, coOwner }) => {
  const cells = [
    {
      key: `co-owner-name-${index}`,
      content: coOwner?.name || '-',
    },

    {
      key: `co-owner-cif-${index}`,
      content: coOwner?.cif || '-',
    },
    {
      key: `co-owner-email-${index}`,
      content: coOwner?.email || '-',
    },

    {
      key: `co-owner-percent-${index}`,
      content: coOwner?.percentage
        ? `${formatNumber(coOwner.percentage)}%`
        : '-',
      textPosition: 'right',
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default CoOwnersTableRow;
